import client from '../client';

export const readDatabaseList = ({ aliasName, dbType, viewType, page }) =>
    client.get(`/api/setting/database-list`, {
        params: {
            alias_name: aliasName,
            db_type: dbType,
            view_type: viewType,
            page,
            pagesize: viewType === 'LIST' ? 14 : 8
        }
    });

export const connectOriginalDB = ({ id }) =>
    client.post('/api/setting/test', { id });

export const connectNewDB = ({ dbType, dbName, hostName, portNumber, accessId, password, aliasName }) =>
    client.post('/api/setting/test/new', { dbType, dbName, hostName, portNumber, accessId, password, aliasName });

export const connectNewSQLite = (formData) => 
    client.post('/api/setting/test/new', formData, {
        headers: {
            'Content-Type': 'multipart/form-data'
        },
        transformRequest: [(data, headers) => { // 인터셉터 우회 옵션
            return data; // 기존 Content-Type 유지
        }]
    });

export const saveDB = ({ dbType, dbName, hostName, portNumber, accessId, password, aliasName }) =>
    client.post('/api/setting/database', { dbType, dbName, hostName, portNumber, accessId, password, aliasName });
    
export const saveSQLite = (formData) => 
    client.post('/api/setting/database', formData, {
        headers: {
            'Content-Type': 'multipart/form-data'
        },
        transformRequest: [(data, headers) => { // 인터셉터 우회 옵션
            return data; // 기존 Content-Type 유지
        }]
    });

export const updateDB = ({ id, dbType, dbName, hostName, portNumber, accessId, password, aliasName }) =>
    client.put('/api/setting/database', { id, dbType, dbName, hostName, portNumber, accessId, password, aliasName });
        
export const updateSQLite = ({ id, formData }) => 
    client.put('/api/setting/database', { id, formData }, {
        headers: {
            'Content-Type': 'multipart/form-data'
        },
        transformRequest: [(data, headers) => { // 인터셉터 우회 옵션
            return data; // 기존 Content-Type 유지
        }]
    });

export const deleteDB = ({ id }) =>
    client.delete('/api/setting/database', {
        data: { id }
    });

export const changeOrder = ({ id, targetOrder }) =>
    client.post('/api/setting/order', { id, targetOrder });

export const cancelConnect = ({ dbType, dbName, hostName, portNumber, accessId, password, dbFile, aliasName }) =>
    client.delete('/api/setting/database', {
        data: { dbType, dbName, hostName, portNumber, accessId, password, dbFile, aliasName }
    });
